



















































































import Vue, { VueConstructor } from 'vue'
import api from '@/api'
import uiState from '../../../../ui-state'

import OtpModal from '@/components/OtpModal.vue'
import CreditLineOverview from '../../components/CreditLineOverview.vue'

export default (Vue as VueConstructor<
  Vue & { $refs: { otpModal: InstanceType<typeof OtpModal> } }
>).extend({
  components: {
    OtpModal,
    CreditLineOverview
  },

  data() {
    return {
      creditLine: null as any,
      errorMessage: '',
      uiState: uiState([
        'idle',
        'fetching',
        'fetched',
        'validating',
        'error_validated',
        'request_otp',
        'submiting_otp',
        'error_otp',
        'validated',
        'low_virtual_account_balance',
        'transfer_failed'
      ])
    }
  },

  computed: {
    creditLineId(): string {
      return this.$route.params.creditLineId
    },

    loading(): boolean {
      return !this.creditLine || this.uiState.is('loading')
    },

    validating(): boolean {
      return this.uiState.is('validating')
    },

    submitingOtp(): boolean {
      return this.uiState.is('submiting_otp')
    },

    showAlreadyValidatedError(): boolean {
      return this.uiState.is('error_validated')
    },

    showLowVirtualBalanceAccount(): boolean {
      return this.uiState.is('low_virtual_account_balance')
    },

    showTransferFailed(): boolean {
      return this.uiState.is('transfer_failed')
    },

    hasFailedProvisions(): boolean {
      return this.failedProvisions.length > 0
    },

    failedProvisions(): any[] {
      return ((this.creditLine && this.creditLine.provisions) || []).filter(
        (p: any) => p.state === 'failed'
      )
    },

    failedProvisionsLabel(): string {
      return this.failedProvisions
        .map((p: any) => (p.otm || '').toUpperCase())
        .join(', ')
    },

    showOtpModal(): boolean {
      return this.uiState.in(['request_otp', 'submiting_otp', 'error_otp'])
    },

    validated(): boolean {
      return this.uiState.is('validated')
    },

    validatedBy(): string {
      return this.uiState.data
        ? `${this.uiState.data.firstname} ${this.uiState.data.lastname}`
        : ''
    }
  },

  async created() {
    this.uiState.set('loading')
    try {
      this.creditLine = await this.fetchCreditLine()
      this.uiState.set('fetched')
    } catch (error) {
      this.uiState.set('idle')
    }
  },

  methods: {
    enrichCreditLine(data: any) {
      const provisions = data.provisions || []
      const mtn = provisions.find((p: any) => p.otm === 'mtn')
      const moov = provisions.find((p: any) => p.otm === 'moov')
      data.mtnProvisionAmount = mtn ? mtn.amount : 0
      data.moovProvisionAmount = moov ? moov.amount : 0
      data.totalProvisionAmount =
        data.mtnProvisionAmount + data.moovProvisionAmount
      data.validated = !!data.validatedAt
      return data
    },
    async fetchCreditLine() {
      const response = await api.get(`/credit-lines/${this.creditLineId}`, {
        params: {
          populate: 'deadlines,organization,createdBy,validatedBy'
        }
      })
      return this.enrichCreditLine(response.data)
    },
    async onValidateClicked(otp?: string) {
      otp ? this.uiState.set('submiting_otp') : this.uiState.set('validating')

      try {
        const data = otp ? { otp } : {}
        await api.put(`/credit-lines/${this.creditLineId}/validate`, data)

        if (otp) {
          this.uiState.set('validated')
          this.creditLine = await this.fetchCreditLine()
        } else {
          this.uiState.set('idle')
        }
      } catch (error) {
        if ((error as any).response) {
          switch ((error as any).response.status) {
            case 409:
              this.uiState.set(
                'error_validated',
                (error as any).response.data.validatedBy
              )
              return
            case 403:
              this.uiState.set('request_otp')
              return
            case 400:
              this.uiState.set('error_otp')
              switch ((error as any).response.data.code) {
                case 'otp_invalid':
                  this.$refs.otpModal.setError('Le code entré est invalide')
                  break
              }
              return
            case 422:
              switch ((error as any).response.data.code) {
                case 'low_fnm_virtual_account_balance':
                  this.errorMessage = `Vous ne disposez pas de suffisamment de fonds sur votre compte ${
                    (error as any).response.data.data.otm
                  } pour effectuer cette opération`
                  this.uiState.set('low_virtual_account_balance')
                  break
                case 'credit_line_provision_transfer_failed':
                  this.errorMessage = (error as any).response.data.message
                  this.uiState.set('transfer_failed')
                  this.creditLine = await this.fetchCreditLine()
                  break
              }
          }
        }
      }
    }
  }
})
